import { render, staticRenderFns } from "./Duplikat.vue?vue&type=template&id=258a9a10"
import script from "./Duplikat.vue?vue&type=script&lang=js"
export * from "./Duplikat.vue?vue&type=script&lang=js"
import style0 from "./Duplikat.vue?vue&type=style&index=0&id=258a9a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports